import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import Title from "../Title";

function CineToneCameraPrivacy() {
  document.title = "CineTone Camera プライバシーポリシー | 株式会社PO";

  return (
    <div id="privacyPage">
      <Header />
      <div className="contents_inner">
        <Title>Privacy Policy</Title>

        <div className="layout">
          <div className="postBox">
            <div className="postWrap" style={{ display: "block" }}>
              <article className="privacyArticle">
                <h2>CineTone Camera プライバシーポリシー</h2>
                <p>制定日：2026年11月2日</p>
                <p>運営者：株式会社PO</p>
                <p>
                  CineTone Camera（以下「本アプリ」）では、ユーザーのプライバシーを尊重し、個人情報の保護に努めています。
                </p>

                <h3>1. 取得する情報について</h3>
                <p>
                  本アプリは、氏名、メールアドレス、住所、電話番号など、個人を特定できる情報を開発者が取得することはありません。また、アカウント登録やログインは不要です。
                </p>
                <p>
                  本アプリの設定内容（選択中のLOOK、フィルムグレイン・ハレーション・ビネットのオン／オフ、フレームレート、解像度、保存形式など）は、ユーザーの端末内にのみ保存されます。
                </p>

                <h3>2. カメラ・マイクの利用について</h3>
                <p>
                  本アプリは、写真および動画を撮影するために端末のカメラを、動画撮影時に音声を収録するためにマイクを利用します。カメラおよびマイクへのアクセスは、ユーザーの許可を得たうえで行います。
                </p>
                <p>
                  撮影した映像・音声およびLOOKの適用などの画像処理は、すべて端末内で行われます。開発者のサーバーや第三者へ送信、収集することはありません。
                </p>

                <h3>3. 写真ライブラリの利用について</h3>
                <p>
                  本アプリは、撮影した写真・動画を保存するために、写真ライブラリへの追加アクセスを利用します。
                </p>
                <p>
                  撮影済みの写真・動画にLOOKを適用する機能では、ユーザーが写真ピッカーで選択した写真・動画のみを読み込みます。選択されていない写真・動画に本アプリがアクセスすることはありません。加工後のデータは新しい写真・動画として保存され、元の写真・動画は変更されません。
                </p>

                <h3>4. 購入・広告について</h3>
                <p>
                  本アプリは買い切り型の有料アプリです。購入および決済は Apple の App Store を通じて行われ、開発者がユーザーの Apple ID やアカウント情報、支払い情報を取得することはありません。
                </p>
                <p>
                  現在、本アプリでは広告の表示および追加のアプリ内課金を行っていません。
                </p>

                <h3>5. アクセス解析について</h3>
                <p>
                  現在、本アプリでは第三者のアクセス解析サービスを利用していません。また、トラッキングを目的とした情報の取得も行っていません。
                </p>

                <h3>6. 第三者への情報提供について</h3>
                <p>
                  本アプリは、ユーザーが撮影・加工した写真や動画、設定内容を第三者へ提供または販売することはありません。ただし、法令に基づく場合はこの限りではありません。
                </p>

                <h3>7. データの管理について</h3>
                <p>
                  本アプリの設定内容は、アプリを削除すると端末から削除されます。写真ライブラリに保存した写真・動画は、アプリを削除しても写真ライブラリに残ります。不要な場合は「写真」アプリから削除してください。
                </p>
                <p>
                  カメラ、マイク、写真ライブラリへのアクセス許可は、端末の「設定」アプリからいつでも変更できます。
                </p>

                <h3>8. プライバシーポリシーの変更について</h3>
                <p>
                  本アプリの機能追加、使用するサービスの変更、法令その他の必要に応じて、本プライバシーポリシーを変更することがあります。
                </p>
                <p>
                  変更後のプライバシーポリシーは、本ページに掲載した時点から適用されます。
                </p>

                <h3>9. お問い合わせ</h3>
                <p>
                  本アプリおよび本プライバシーポリシーに関するお問い合わせは、開発者Webサイトのお問い合わせ窓口よりお願いいたします。
                  <br />
                  株式会社PO
                  <br />
                  <a href="/#contact" className="link">
                    お問い合わせフォームはこちら
                  </a>
                </p>

                <p style={{ marginTop: "28px" }}>
                  制定日：2026年11月2日
                  <br />
                  CineTone Camera
                </p>
              </article>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CineToneCameraPrivacy;
